import React from "react";

export const educationData = [
	{
		university: "Stevens Institute Of Technology",
		program: "Master Of Science in Computer Software Engineering",
		year: "2021-2023",
		location: "Jersey, USA",
	},
	{
		university: "Savitribai Phule Pune University",
		program: "Bachelor of Engineering in Civil Engineering",
		year: "2013-2018",
		location: "India",
	},
];

function Education() {
	return (
		<div className="w-full max-w-5xl mx-auto px-2 sm:px-6 md:px-8 space-y-4">
			{educationData.map((education, idx) => (
				<div
					key={idx}
					className="flex flex-col md:flex-row md:items-center md:justify-between space-y-1 md:space-y-0"
				>
					<div>
						<h2 className="text-xl font-semibold text-[#213448] dark:text-slate-100">
							{education.university}
						</h2>
						<p className="text-md font-medium text-gray-700 dark:text-slate-300">
							{education.program}
						</p>
					</div>
					<div className="mt-2 text-left text-gray-500 dark:text-slate-400 md:mt-0 md:text-right">
						<div className="text-sm">{education.year}</div>
						<div className="text-sm">{education.location}</div>
					</div>
				</div>
			))}
		</div>
	);
}

export default Education;
